import { useAuthStore } from '../../../stores/login';
import { useCartStore } from '../../../stores/cart';
import { LoyaltyPointReward } from '../../../queries/loyalty/types';
import { Toast } from '@onbeefapp/constants';
import { OrderDetailsContext } from '../../../contexts/OrderDetailsContext';
import React from 'react';
import { useMerchantStore } from '../../../stores/merchant';
import { useRefreshLoyaltyData } from '../../../queries/loyalty';

export const useCartLoyaltyPoints = () => {
  const { user, updateLoyalty } = useAuthStore((state) => ({
    user: state.user,
    updateLoyalty: state.updateLoyalty,
  }));

  const { selectedPointReward, setSelectedPointReward } = useCartStore(
    (state) => ({
      selectedPointReward: state.selectedPointReward,
      setSelectedPointReward: state.setSelectedPointReward,
    }),
  );

  const merchantLoyaltyProgramme = useMerchantStore(
    (state) => state.loyalty_programme,
  );

  const { mutateAsync: refreshLoyaltyData, isLoading: isRefreshingLoyalty } =
    useRefreshLoyaltyData();

  const { subtotalWithDiscount } = React.useContext(OrderDetailsContext);

  const userLoyalty = user?.loyalty_programmes?.find(
    (loyalty) => loyalty.merchant_id === merchantLoyaltyProgramme?.merchant_id,
  );

  const availablePoints = userLoyalty?.reward?.customer_points?.available || 0;

  const handleRefreshLoyalty = async () => {
    const data = await refreshLoyaltyData();
    if (data) {
      updateLoyalty(data);
    }
  };

  const handleSelectReward = (reward: LoyaltyPointReward) => {
    if (selectedPointReward?.id === reward.id) {
      handleClearSelectedReward();
      return;
    }
    if (availablePoints < reward.quantity_points) {
      Toast.error('Você não tem pontos suficientes para resgatar este prêmio');
      return;
    }
    setSelectedPointReward(reward);
  };

  const handleClearSelectedReward = () => {
    setSelectedPointReward(undefined);
  };

  const getCurrentOrderPoints = () => {
    if (
      !subtotalWithDiscount ||
      !merchantLoyaltyProgramme?.reward?.points_per_currency
    )
      return 0;

    return Math.floor(
      subtotalWithDiscount *
        parseFloat(merchantLoyaltyProgramme?.reward?.points_per_currency),
    );
  };

  return {
    handleSelectReward,
    handleClearSelectedReward,
    selectedPointReward,
    getCurrentOrderPoints,
    handleRefreshLoyalty,
    isRefreshingLoyalty,
  };
};
